import React from 'react';

import { getTranslation, keys } from '../../../../../../../Resources/Translations';
import { post } from '../../../../../../ReactComponents/API';
import Form from '../../../../../../ReactComponents/Form/Form';
import { FormFields, FormSubmitData, FormSubmitStatus } from '../../../../../../ReactComponents/Form/FormInterfaces';
import { RegexProvider } from '../../../../../../ReactComponents/RegexProvider';
import { VippsPaymentApi } from '../../../Components/VippsPayment/VippsPaymentApi';
import { VippsInitiatePaymentType } from '../VippsInitiatePaymentType.csharp';
import { VippsPageProps } from './VippsPageProps.csharp';

export const VippsExpress = (props: VippsPageProps) => {
    const vippsPaymentApi = React.useRef(new VippsPaymentApi(props.routes));
    const fields = React.useRef(getVippsExpressFields(props.model.ageValidationNeeded));

    const handleOnSubmit = async (data: FormSubmitData): Promise<FormSubmitStatus | boolean> => {
        const redirectToVipps = async (): Promise<boolean> => {
            return await vippsPaymentApi.current
                .redirectToVipps(data.phoneNumber as string, VippsInitiatePaymentType.Express)
                .then(() => true)
                .catch(() => false);
        };

        if (props.model.ageValidationNeeded) {
            const response = await post(props.routes.ssnValidationUrl, { socialSecurityNumber: data.ssn });
            const value = await response.json();

            if (value?.error) {
                return { isSuccess: false, validationErrors: [{ key: 'ssn', message: getTranslation(keys['vippsExpress.invalidSsn']) }] };
            } else {
                return await redirectToVipps();
            }
        } else {
            return await redirectToVipps();
        }
    };

    return (
        <>
            <div className="CheckoutPage__BackButton">
                <a className="CheckoutPage__ContinueShopping" href={props.cartUrl}>
                    <span>{getTranslation(keys['checkout.backToCart'])}</span>
                </a>
            </div>
            <div className="VippsExpress">
                <h1 className="VippsExpress__Heading">{getTranslation(keys['vippsExpress.heading'])}</h1>
                <span className="VippsExpress__Subheading">{getTranslation(keys['vippsExpress.subheading1'])}</span>
                <span className="VippsExpress__Subheading">{getTranslation(keys['vippsExpress.subheading2'])}</span>
                <img className="VippsExpress__Logo" src="/dist/assets/images/guest-checkout.svg" alt={getTranslation(keys['vippsExpress.heading'])} />
                <Form
                    inputs={fields.current}
                    onSubmit={handleOnSubmit}
                    submitButtonText={getTranslation(keys['vippsExpress.button'])}
                    persistStateOnSubmit
                    withButtonLoader
                />
            </div>
        </>
    );
};

const getVippsExpressFields = (requireAgeValidation: boolean): FormFields => {
    const fields: FormFields = {
        phoneNumber: {
            displayName: getTranslation(keys['vippsExpress.phoneNumber']),
            validation: {
                regEx: [
                    {
                        value: RegexProvider.phoneNumber,
                        message: getTranslation(keys['checkout.incorrectPhone'])
                    }
                ],
                required: { value: true }
            },
            autocomplete: 'tel-national'
        }
    };

    if (requireAgeValidation) {
        fields.ssn = {
            displayName: getTranslation(keys['vippsExpress.ssn']),
            validation: {
                regEx: [
                    {
                        value: RegexProvider.ssn,
                        message: getTranslation(keys['vippsExpress.invalidSsn'])
                    }
                ],
                required: { value: true }
            }
        };
    }

    return fields;
};
